import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Skeleton from '../../../Common/Skeleton/Skeleton'
import s from './PaymentCardSkeleton.css'

function PaymentCardSkeleton() {
    return (
        <div>
            <div className={s.paymentCardSkeletonBox}>
                <div className={s.paymentCardTabSkeletonContainer}>
                    <div className={s.paymentCardTabSkeletonWrapper}>
                        <Skeleton className={s.paymentCardTabSkeleton} />
                        <Skeleton className={s.paymentCardTabSkeleton} />
                    </div>
                </div>
                <div className="twoColumnGrid">
                    {[1, 2].map((n) => <div key={n}>
                        <Skeleton className={cx(s.paymentCardLabelSkeleton, s[`paymentCardLabelSkeleton${n}`])} />
                        <Skeleton className={s.paymentCardInputSkeleton} />
                    </div>)}
                </div>
            </div>
            <div className='commonButtonContainer'>
                <Skeleton className={cx(s.paymentCardBtn, s.paymentCardBackBtn)} />
                <Skeleton className={cx(s.paymentCardBtn, s.paymentCardSaveBtn)} />
            </div>
        </div>
    )
}

export default withStyles(s)(PaymentCardSkeleton);
